import script from "./ClassReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__